/* 基于element 扩展一下confirm弹框，结合蓝桥业务场景 */

import Vue from 'vue'
import { Loading } from 'element-ui'
Vue.prototype.$LqConfirm = window.$LqConfirm = (content, options) => {
  if (!content) {
    return console.error('缺少content')
  }
  if (!options && typeof options != 'object') {
    return console.error(`options参数没有或者类型错误`)
  }
  var title = options.title || '提示'
  // 添加 tmscode
  title = title + '：' + (($ && $.getCookie && $.getCookie('tmscode')) || '')
  options = Object.assign(options, {
    closeOnClickModal: false,
    customClass: 'lq-global-confirm-wrap' + (options.customClass ? ' ' + options.customClass : ''),
    cancelButtonClass: 'lq-global-confirm-cancel-btn',
    confirmButtonClass: 'lq-global-confirm-confirm-btn'
  })
  return Vue.prototype.$confirm(content, title, options)
}

// 全局loading
// maxDelay 最长显示时间
// options参数同element的全局loading参数
let loadingTimer = null
let loadingInstance = null
Vue.prototype.$LqLoading = window.$LqLoading = (options, maxDelay) => {
  if (!Vue.prototype.$loading) {
    return
  }
  clearTimeout(loadingTimer)
  maxDelay = maxDelay || 5 * 60 * 1000 // 最大时间五分钟
  const baseOpt = {
    customClass: 'lq-custom-loading-wrap',
    fullscreen: true
  }
  options = Object.assign(baseOpt, options || {})
  // 这里换成service引入，是为了使用单例模式，避免重复生成loading实例
  loadingInstance = Loading.service(options)
  loadingTimer = setTimeout(() => {
    clearTimeout(loadingTimer)
    loadingInstance.close && loadingInstance.close()
  }, maxDelay)
  return loadingInstance
}
